import React, { useState } from 'react';
import axios from 'axios';

const ContactPage = ({ setCurrentPage }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/api/contact', formData);
      setIsSubmitted(true);
      
      // Reset form after 3 seconds
      setTimeout(() => {
        setIsSubmitted(false);
        setFormData({ name: '', email: '', subject: '', message: '' });
      }, 3000);
    } catch (error) {
      console.error('Erreur lors de l\'envoi:', error);
      alert('Erreur lors de l\'envoi du message. Veuillez réessayer.');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <button onClick={() => setCurrentPage('home')} className="flex items-center gap-2 text-gray-600 hover:text-gray-900">
              ← Retour à l'accueil
            </button>
            
            {/* Desktop Menu */}
            <div className="hidden md:flex gap-2">
              <button onClick={() => setCurrentPage('admin')} className="px-3 py-1 text-sm font-medium text-primary-700 bg-primary-50 rounded hover:bg-primary-100">Admin</button>
              <button onClick={() => setCurrentPage('student')} className="px-3 py-1 text-sm font-medium text-blue-700 bg-blue-50 rounded hover:bg-blue-100">Étudiant</button>
              <button onClick={() => setCurrentPage('teacher')} className="px-3 py-1 text-sm font-medium text-green-700 bg-green-50 rounded hover:bg-green-100">Enseignant</button>
            </div>
            
            {/* Mobile Menu Button */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2 rounded-lg text-gray-600 hover:text-gray-900 hover:bg-gray-100">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {mobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
          
          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden pb-4">
              <div className="flex flex-col space-y-2">
                <button onClick={() => { setCurrentPage('admin'); setMobileMenuOpen(false); }} className="w-full text-left px-3 py-2 text-sm font-medium text-primary-700 bg-primary-50 rounded hover:bg-primary-100">Admin</button>
                <button onClick={() => { setCurrentPage('student'); setMobileMenuOpen(false); }} className="w-full text-left px-3 py-2 text-sm font-medium text-blue-700 bg-blue-50 rounded hover:bg-blue-100">Étudiant</button>
                <button onClick={() => { setCurrentPage('teacher'); setMobileMenuOpen(false); }} className="w-full text-left px-3 py-2 text-sm font-medium text-green-700 bg-green-50 rounded hover:bg-green-100">Enseignant</button>
              </div>
            </div>
          )}
        </div>
      </nav>
      
      {/* Header */}
      <div className="bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Contactez-nous</h1>
          <p className="text-xl text-gray-600">Une question ? Un problème ? N'hésitez pas à nous contacter</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Contact Info Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          <div className="bg-white p-6 rounded-lg shadow-sm text-center">
            <div className="text-3xl mb-4">📧</div>
            <h3 className="font-semibold text-gray-900 mb-2">Email</h3>
            <p className="text-sm text-gray-600">contact@chronaxis.tn</p>
            <p className="text-sm text-gray-600">oualid.hamami@gafsa.r-iset.tn</p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-sm text-center">
            <div className="text-3xl mb-4">📞</div>
            <h3 className="font-semibold text-gray-900 mb-2">Téléphone</h3>
            <p className="text-sm text-gray-600">+216 98 559 121</p>
            <p className="text-sm text-gray-600">Lun-Ven: 8h00-17h00</p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-sm text-center">
            <div className="text-3xl mb-4">📍</div>
            <h3 className="font-semibold text-gray-900 mb-2">Adresse</h3>
            <p className="text-sm text-gray-600">ISET Gafsa</p>
            <p className="text-sm text-gray-600">Sidi Ahmed Zarroug, Gafsa 2112</p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-sm text-center">
            <div className="text-3xl mb-4">🕒</div>
            <h3 className="font-semibold text-gray-900 mb-2">Horaires de support</h3>
            <p className="text-sm text-gray-600">Lundi - Vendredi: 8h00 - 17h00</p>
            <p className="text-sm text-gray-600">Samedi: 8h00 - 12h00</p>
          </div>
        </div>

        {/* Contact Form */}
        <div className="bg-white rounded-lg shadow-sm p-8">
          {!isSubmitted ? (
            <form onSubmit={handleSubmit}>
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Envoyez-nous un message</h2>
              
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">Nom complet *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Votre nom complet"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="votre.email@exemple.com"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
              </div>
              
              <div className="mb-6">
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">Sujet *</label>
                <select
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">Sélectionnez un sujet</option>
                  <option value="support">Support technique</option>
                  <option value="bug">Signaler un bug</option>
                  <option value="feature">Demande de fonctionnalité</option>
                  <option value="account">Problème de compte</option>
                  <option value="other">Autre</option>
                </select>
              </div>
              
              <div className="mb-6">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  placeholder="Décrivez votre demande en détail..."
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                ></textarea>
              </div>
              
              <button type="submit" className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 font-medium">
                Envoyer le message
              </button>
            </form>
          ) : (
            <div className="text-center py-12">
              <div className="text-6xl mb-4">✅</div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">Message envoyé avec succès !</h2>
              <p className="text-gray-600">Nous vous répondrons dans les plus brefs délais.</p>
            </div>
          )}
        </div>
      </div>

      {/* FAQ Section */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">Questions fréquentes</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="font-semibold text-gray-900 mb-3">Comment accéder à l'espace admin ?</h3>
              <p className="text-gray-600 text-sm">Cliquez sur "Admin" dans le menu principal. Vous devez avoir un compte administrateur pour accéder à cette section.</p>
            </div>
            
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="font-semibold text-gray-900 mb-3">Les étudiants peuvent-ils modifier leur emploi du temps ?</h3>
              <p className="text-gray-600 text-sm">Non, l'espace étudiant est en lecture seule. Seuls les administrateurs peuvent modifier les emplois du temps.</p>
            </div>
            
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="font-semibold text-gray-900 mb-3">Comment signaler un problème technique ?</h3>
              <p className="text-gray-600 text-sm">Utilisez le formulaire de contact ci-dessus en sélectionnant "Support technique" comme sujet.</p>
            </div>
            
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="font-semibold text-gray-900 mb-3">L'application est-elle accessible sur mobile ?</h3>
              <p className="text-gray-600 text-sm">Oui, Chronaxis est entièrement responsive et fonctionne parfaitement sur tous les appareils.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;